// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3Bn2P","title":"Images90_title__10EI8","images":"Images90_images__3HOEs"};